export default class AttributePreviewImageController {

    constructor($scope, $uibModalInstance, $timeout, file) {
        'ngInject';

        this.$uibModalInstance = $uibModalInstance;
        this.$scope = $scope;
        this.$scope.file = file;

        this.$scope.close = () => {
            this.$uibModalInstance.close();
        }
    }
}
